import { render, staticRenderFns } from "./RequisitionDetails.vue?vue&type=template&id=5279e712&lang=pug&"
import script from "./RequisitionDetails.vue?vue&type=script&lang=js&"
export * from "./RequisitionDetails.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports